import React from "react";
import { Typography, Box, Button } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { useNavigate } from "react-router-dom";
import Content from "./Content";

const FeatureDisabled = ({ featureName, isSubscriptionExpired }) => {
  const navigate = useNavigate();

  const title = isSubscriptionExpired
    ? "اشتراک منقضی شده است"
    : "این بخش غیرفعال است";
  const description = isSubscriptionExpired
    ? "اشتراک این سایت منقضی شده است. برای استفاده از خدمات، لطفاً اشتراک خود را تمدید کنید."
    : `${featureName} در حال حاضر غیرفعال شده است. لطفاً بعداً مراجعه کنید.`;

  return (
    <Content>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "50vh",
          textAlign: "center",
          py: 4,
        }}
      >
        <BlockIcon sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
        <Typography variant="h5" gutterBottom fontWeight="bold">
          <span> {title}</span>
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          <span> {description}</span>
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            if (isSubscriptionExpired) {
              debugger;
              navigate("/subscription");
            } else {
              navigate("/");
            }
          }}
          sx={{ borderRadius: 2 }}
        >
          {isSubscriptionExpired ? (
            <span> تمدید اشتراک</span>
          ) : (
            <span> بازگشت به صفحه اصلی</span>
          )}
        </Button>
      </Box>
    </Content>
  );
};

export default FeatureDisabled;
